import React, { useState, useEffect, useRef } from 'react';
import posed from 'react-pose';
import HamburgerButton from './components/hamburger-button';
import { styled, Media, Colors } from '../../themes';
import { space } from 'styled-system';
import { Link, Text, Box } from 'components';
import { graphql, useStaticQuery } from 'gatsby';
// import { navigate } from '@reach/router';
import Button from 'components/buttons';
import { IoMdOpen } from 'react-icons/io';
import { ROUTES } from 'navigation/route-map';
import { useTranslation } from 'react-i18next';

const SideMenuContainer = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  const [t, i18n] = useTranslation();

  function onClickOutside(event) {
    if (containerRef.current === event.target) {
      setShow(false);
    }
  }

  function onToggleMenu() {
    setShow(!show);
  }

  // async function onChangeLanguage() {
  //   const { location, navigate } = props;
  //   const currentLanguage = i18n.language;
  //   debugger
  //   if (currentLanguage == 'en') {
  //     i18n.changeLanguage('sv')
  //     await navigate('/');
  //   } else {
  //     i18n.changeLanguage('en')
  //     await navigate(`/en`);
  //   }
  //   setShow(false);
  // }

  useEffect(() => {
    document.addEventListener('click', onClickOutside, false);
    return () => {
      document.removeEventListener('click', onClickOutside, false);
    };
  }, []);

  return (
    <Container ref={containerRef} isActive={show}>
      <HamburgerButton active={show} onPress={onToggleMenu} />
      <SideMenu initialPose={'closed'} pose={show ? 'open' : 'closed'}>
        <List>
          <NavItemWrapper mb={[2]} color={'darkOrange'}>
            <Link to={ROUTES.HOME}>
              {t('section--side-menu.navigation.home')}
            </Link>
          </NavItemWrapper>
          <NavItemWrapper mb={[2]} color={'darkOrange'}>
            <Link to={ROUTES.YEP}>
              {t('section--side-menu.navigation.yep')}
            </Link>
          </NavItemWrapper>
          <NavItemWrapper mb={[2]} color={'darkOrange'}>
            <Link to={'https://support.yepstr.com'} target={'_blank'}>
              {t('section--side-menu.navigation.support')}
            </Link>
            <IoMdOpen />
          </NavItemWrapper>
          <NavItemWrapper mb={[2]} color={'darkOrange'}>
            <Link to={ROUTES.ABOUT}>{t('section--side-menu.navigation.about')}</Link>
          </NavItemWrapper>
          <NavItemWrapper mb={[2]} color={'darkOrange'}>
            <Link to={'https://www.yepstr.com/blog'} target={'_blank'}>
              {t('section--side-menu.navigation.blog')}
            </Link>
            <IoMdOpen />
          </NavItemWrapper>

          <Text fontSize={[1]} color="battleshipGrey" mt={[4]} mb={[2]}>
            {t('section--side-menu.category-heading')}
          </Text>
          {/* {data.allStrapiCategory.edges.map(node => {
            return (
              <NavItemWrapper key={node.node.id} mb={[1]} fontSize={1}>
                <Link
                  to={
                    node.node.isCompany
                      ? 'https://business.yepstr.com'
                      : `/bestallare/${node.node.slug}`
                  }
                  target={node.node.isCompany ? '_blank' : ''}
                >
                  {node.node.title}
                </Link>
                {node.node.isCompany && <IoMdOpen />}
              </NavItemWrapper>
            );
          })} */}
          <NavItemWrapper mb={[1]} fontSize={1}>
            <Link
              to={ROUTES.BABYSITTING}
              // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.navigation.babysitting')}
            </Link>
            {/* {node.node.isCompany && <IoMdOpen />} */}
          </NavItemWrapper>
          <NavItemWrapper mb={[1]} fontSize={1}>
            <Link
              to={ROUTES.HOMEWORK}
              // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.navigation.homework')}
            </Link>
            {/* {node.node.isCompany && <IoMdOpen />} */}
          </NavItemWrapper>
          <NavItemWrapper mb={[1]} fontSize={1}>
            <Link
              to={ROUTES.GARDENING}
              // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.navigation.gardening')}
            </Link>
            {/* {node.node.isCompany && <IoMdOpen />} */}
          </NavItemWrapper>
          <NavItemWrapper mb={[1]} fontSize={1}>
            <Link
              to={ROUTES.DOGMINDING}
              // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.navigation.dog-minding')}
            </Link>
            {/* {node.node.isCompany && <IoMdOpen />} */}
          </NavItemWrapper>
          <NavItemWrapper mb={[1]} fontSize={1}>
            <Link
              to={ROUTES.EVENT}
              // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.navigation.event')}
            </Link>
            {/* {node.node.isCompany && <IoMdOpen />} */}
          </NavItemWrapper>
          <NavItemWrapper mb={[1]} fontSize={1}>
            <Link
              to={'https://business.yepstr.com'}
              // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.navigation.company')}
            </Link>
            {/* {node.node.isCompany && <IoMdOpen />} */}
          </NavItemWrapper>
          <NavItemWrapper mt={[3]} mb={[2]} color={'darkOrange'}>
            <Link
              to={ i18n.language == 'sv' ? '/en' : '/'}
            // target={node.node.isCompany ? '_blank' : ''}
            >
              {t('section--side-menu.change-language')}
            </Link>
          </NavItemWrapper>
        </List>
        <ButtonWrapper>
          <Button
            to={ROUTES.DOWNLOAD}
            label={t('section--side-menu.navigation.download')}
          />
        </ButtonWrapper>
      </SideMenu>
    </Container>
  );
};

const sidebarProps = {
  open: {
    width: '100%',
    transition: {
      opacity: { ease: 'linear', duration: 400 },
      default: { ease: 'easeOut', duration: 500 },
    },
    staggerChildren: 100,
  },
  closed: {
    width: '0',
    transition: {
      opacity: { ease: 'linear', delay: 500, duration: 1000 },
      default: { ease: 'easeOut', duration: 300 },
    },
  },
};

const navItemProps = {
  open: {
    opacity: 1,
    x: '0%',
    transition: {
      default: { ease: 'linear', duration: 400 },
    },
  },
  closed: {
    opacity: 0,
    x: '400px',
    transition: {
      default: { ease: 'easeOut', duration: 3000 },
    },
  },
};

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  visibility: ${props => props.show};
  background-color: ${({ isActive }) =>
    isActive ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'};
  transform: all 0.1s ease;
  pointer-events: ${({ isActive }) => (isActive ? 'auto' : 'none')};
  z-index: 15;
`;

const SideMenu = styled(posed.nav(sidebarProps))`
  pointer-events: all;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 0;
  max-width: 100vw;
  background-color: ${Colors.white};
  box-shadow: -12px 0px 47px 0px rgba(0, 0, 0, 0.3);
  overflow-y: scroll;

  ${Media.tablet} {
    max-width: 400px;
  }
`;

const List = styled(posed.ul(navItemProps))`
  margin: 75px 25px 0;
  padding-left: 0;

  ${Media.tablet} {
    margin: 75px 50px 0;
  }
`;

const NavItemWrapper = styled.li`
  ${space};

  display: flex;

  align-items: center;

  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  list-style: none;
  color: ${props => props.theme.colors.silver};

  & > a:visited,
  & > a:link {
    margin-right: 1rem;
    text-decoration: none;
    color: ${props => props.theme.colors.darkOrange};
  }

  ${Media.tablet} {
    font-size: 24px;
  }
`;

const ButtonWrapper = styled(Box)`
  margin: 25px 25px;
  padding-left: 0;
  white-space: nowrap;

  ${Media.tablet} {
    margin: 50px 50px;
  }
`;

const StyledButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  font-size: 18px;
  font-weight: 700;
  color: ${props => props.theme.colors.darkOrange};
`;

export default SideMenuContainer;
